import Vue from 'vue';
import Vuex from 'vuex';
import authModule from "./modules/auth";
import topicModule from "./modules/topic";
import notifications from './modules/notifications';
import config from './modules/config';
Vue.use(Vuex);



const store = new Vuex.Store({
  modules:{
    auth: authModule,
    topic: topicModule,
    notifications: notifications,
    config: config
  }
});


export default store;